import React, { useEffect, useRef, useState } from 'react'
import { FileUpload } from 'primereact/fileupload'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { Image } from 'primereact/image'
import { Button } from 'primereact/button'
import DeleteButton from '../../../../components/common/buttons/DeleteButton'
import SaveButton from '../../../../components/common/buttons/SaveButton'
import LabeledCalendar from '../../../../components/common/form-components/labeled-calendar/LabeledCalendar'
import useInputs from '../../../../utils/hooks/useInputs'
import CenterService, {
  uploadFile,
} from '../../../../services/centers/center.service'
import LabeledText from '../../../../components/common/form-components/labeled-inputs/LabeledText'
import { env } from '../../../../utils/constants/env-vars'
import endpointsCenters from '../../../../services/centers/endpoints'
import LabeledFile from '../../../../components/common/form-components/labeled-file/LabeledFile'
import swalAlert from '../../../../utils/helpers/swalAlert'
import PdfView from '../../../../components/pdf-view/PdfView'
import { AppModalContent } from '../../../../component/layout/AppModal'
import { Group, Stack } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import AppButton from '../../../../component/common/AppButton'
import AppFileInput from '../../../../component/form/AppFileInput'
import AppInput from '../../../../component/form/AppInput'
import AppFileButton from '../../../../component/common/AppFileButton'

const CenterContractsFileForm = ({ centerId, selectedItem, close }) => {
  const fileRef = useRef(null)
  const [fileData, setFileData] = useState()
  const [fileName, setFileName] = useState()
  const { formatMessage: msg } = useIntl()
  const { t } = useTranslation()
  const { inputs, onChangeInputs, updateInputs } = useInputs()

  const [file, setFile] = useState()

  useEffect(() => {
    if (selectedItem?._id) {
      updateInputs(selectedItem)
      retrieveFile()
    }
    // TODO: Como cargar en inputs?.files el archivo existente?
  }, [selectedItem])

  useEffect(() => {
    if (inputs?.files?.[0]) {
      setFileData(URL?.createObjectURL(inputs?.files?.[0]))
      setFileName(inputs?.files?.[0]?.name)
      if (!inputs?.description)
        updateInputs({ ...inputs, description: inputs?.files?.[0]?.name })
    }
  }, [inputs])

  const retrieveFile = async () => {
    if (selectedItem && selectedItem?._id && selectedItem?.mimeType) {
      const response = await CenterService.contracts.file.getById({
        id: centerId,
        rowId: selectedItem?._id,
      })
      if (response !== null && response !== 'null') {
        const blob = new Blob([response], { type: selectedItem.mimeType })
        if (blob && blob?.type !== '') {
          const url = URL.createObjectURL(blob)
          setFileData(url)
        } else {
          setFileData(null)
        }
      }
    }
  }

  const handleSave = async () => {
    const formData = new FormData()

    console.log('handleSave', file)
    formData.append('description', file?.name || '-')
    formData.append('file', inputs?.files?.[0])

    // if (fileRef?.current?.getFiles().length > 0) {
    //     Object.entries(fileRef?.current?.getFiles()).forEach(([key, value]) => {
    //         formData.append('description', inputs?.description || '-')
    //         formData.append('file', value)
    //     })
    // } else {
    //     formData.append('description', inputs?.description || '-')
    // }
    // console.log('handleSave', inputs, (!inputs?._id))
    const response = !inputs?._id
      ? await CenterService.contracts.file.create({
          id: centerId,
          body: formData,
        })
      : await CenterService.contracts.file.update({
          id: centerId,
          rowId: inputs?._id,
          body: {
            description: inputs?.description || '-',
          },
        })
    // console.log('handleSave', response)
    if (response) close()
  }

  const handleRemove = async () => {
    if (selectedItem?._id) {
      const response = await CenterService.contracts.file.remove({
        id: centerId,
        rowId: selectedItem?._id,
      })
      if (response) {
        close()
        swalAlert('success', msg({ id: 'fileDeleted' }))
      } else {
        swalAlert('error', msg({ id: 'fileDeleteError' }))
      }
    }
  }

  return (
    <AppModalContent
      buttons={[
        <AppButton
          preset="remove"
          invisible={!selectedItem?._id}
          onClick={handleRemove}
        />,
        <AppFileButton
          name="files"
          ref={fileRef}
          accept="application/pdf,image/*"
          onChange={onChangeInputs}

          // onChange={(_value) => {
          //     console.log('onChange', _value)
          //     console.log('onChange', _value?.files?.[0]?.name)
          //     setFileName(_value?.files?.[0]?.name)
          //     onChangeInputs({ files: _value })
          // }}
        />,
        <AppButton
          preset="save"
          disabled={!inputs?.files?.[0]}
          onClick={handleSave}
        />,
      ]}
      content={
        <Stack w="100%" h="100%">
          <Group>
            <AppInput
              label="description"
              withAsterisk
              name="description"
              value={inputs?.description}
              onChange={onChangeInputs}
            />
          </Group>
          {!fileData && (
            <Group
              w="100%"
              mih={480}
              justify="center"
              className="iframe-empty"
              onClick={() =>
                document.querySelector("input[type='file']").click()
              }
            >
              {t('uploadFile')}
            </Group>
          )}
          {fileData && (
            <Group w="100%" mih={480} h={480}>
              <iframe
                src={fileData}
                title="Preview"
                style={{ width: '100%', minHeight: '480px' }}
              />
            </Group>
          )}
          <Group w="100%" justify="flex-end" fz="80%">
            {inputs?.files?.[0]?.name}
          </Group>
        </Stack>
      }
    />
  )
}

export default CenterContractsFileForm
